import React, { useState } from "react"
import { Icon, Message } from "semantic-ui-react"
import { useRemoveFeatureFromOrg } from "../../../Hooks/FetchHooks/DeleteDataService/useRemoveFeatureFromOrg"
import BifrostButton from "../../BifrostElementComponent/BifrostButton/BifrostButton"
import BifrostModal from "../BifrostModal/BifrostModal"
import Loader from "../Loader/Loader"

const RemoveFeatureFromOrgModal = ({ feature, org, refreshData }) => {
	const [openModal, setOpenModal] = useState(false)
	const [mouseHover, setMouseHover] = useState(false)

	const { isLoading, isError, setIsError, removeFeatureFromOrg } = useRemoveFeatureFromOrg()

	const submitHandler = () => {
		removeFeatureFromOrg(org.id, feature.id).then(() => {
			setOpenModal(false)
			refreshData()
		})
	}

	const cancelHandler = () => {
		console.log("cancelHandler")
		setOpenModal(false)
		setIsError(false)
	}

	return (
		<BifrostModal
			title={"Remove Feature \"" + feature.name + "\" from Organization"}
			open={openModal}
			setOpen={setOpenModal}
			closeOnEscape={!isLoading}
			closeOnDimmerClick={!isLoading}
			trigger={
				<Icon
					name="minus"
					size="small"
					circular={true}
					onMouseEnter={() => setMouseHover(true)}
					onMouseLeave={() => setMouseHover(false)}
					style={{
						color: "darkred",
						backgroundColor: mouseHover ? "lightgrey" : null
					}}
				/>
			}
			modalPage={
				<>
					{isLoading ? (
						<Loader backgroundColor="white" inverted height="1px" minHeight="20px" />
					) : isError ? (
						<Message negative>
							<p> Something went wrong</p>
						</Message>
					) : (
						<p style={{ color: "black" }}>
							Are you sure you want to remove feature <b>"{feature.name}"</b> from <b>{org && org.name}</b>?
						</p>
					)}
				</>
			}
			modalActions={
				<>
					{!isError && !isLoading && (
						<BifrostButton
							disabled={isLoading}
							style={{ display: "inline-block" }}
							onClick={(e) => {
								e.stopPropagation()
								submitHandler()
							}}
							color="red"
						>
							Remove
						</BifrostButton>
					)}
					<BifrostButton
						color="gray"
						style={{ display: "inline-block" }}
						onClick={(e) => {
							e.stopPropagation()
							cancelHandler()
						}}
					>
						Cancel
					</BifrostButton>
				</>
			}
		/>
	)
}

RemoveFeatureFromOrgModal.propTypes = {}

export default RemoveFeatureFromOrgModal
